import { apiGet, apiPost, apiPut, MENTOR_API_URI } from './index';

const mentor = {
    get: async (tutorialId: number) => {
        const data = await apiGet(`${MENTOR_API_URI}/api/tutorial/get?tutorialId=${tutorialId}`);
        return data;
    },
    getAllTutorials: async (platformId: number) => {
        const data = await apiGet(`${MENTOR_API_URI}/api/tutorial/getall/active?platformId=${platformId}`);
        return data;
    },
    getPlatforms: async () => {
        const data = await apiGet(`${MENTOR_API_URI}/api/platform/getall`);
        return data;
    },
    getTutorialSteps: async (tutorialId: number) => {
        const data = await apiGet(`${MENTOR_API_URI}/api/tutorialstep/getall?tutorialId=${tutorialId}`);
        return data;
    },
    getTutorialDocument: async (tutorialId: number) => {
        const data = await apiGet(`${MENTOR_API_URI}/api/tutorialdocument/getall?tutorialId=${tutorialId}`);
        return data;
    },
    getTutorialVideo: async (tutorialId: number) => {
        const data = await apiGet(`${MENTOR_API_URI}/api/tutorialvideo/get?tutorialId=${tutorialId}`);
        return data;
    },
    getPageTutorials: async (pathName: string) => {
        const data = await apiGet(`${MENTOR_API_URI}/api/tutorial/getall/pageLocation?pathName=${pathName}`);
        return data;
    },
    getUserTutorials: async (contactId: number) => {
        const data = await apiGet(`${MENTOR_API_URI}/api/tutorialcontact/get?contactId=${contactId}`);
        return data;
    },
    getAllTutorialVideos: async () => {
        const data = await apiGet(`${MENTOR_API_URI}/api/tutorialvideo/getall`);
        return data;
    },
    registerTutorial: async (tutorialId: number, contactId: number) => {
        const data = await apiPost(`${MENTOR_API_URI}/api/tutorialcontact/insertRegistration?tutorialId=${tutorialId}&contactId=${contactId}`);
        return data;
    },
    setUserTutorialProgress: async (tutorialContactId: number, stepNumber: number) => {
        const data = await apiPut(`${MENTOR_API_URI}/api/tutorialcontact/update?tutorialContactId=${tutorialContactId}&stepNumber=${stepNumber}`);
        return data;
    },
    setUserTutorialComplete: async (tutorialContactId: number) => {
        const data = await apiPut(`${MENTOR_API_URI}/api/tutorialcontact/update/complete?id=${tutorialContactId}`);
        return data;
    },
    downloadVideo: async (fileName: string) => {
        const data = await apiGet(`${MENTOR_API_URI}/api/tutorialvideo/download?fileName=${fileName}`);
        return data;
    },
    downloadDocument: async (fileName: string) => {
        const data = await apiGet(`${MENTOR_API_URI}/api/tutorialdocument/download?fileName=${fileName}`);
        return data;
    }
    
}

export default mentor;